/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import SiteNavigation from "../components/header/siteNavigation"
import Footer from "../components/footer/footer"
import "./custom.scss"

const Layout = ({ children }) => {
  return (
    <>
      <SiteNavigation />
      {children}
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
